/**
 * @flow
 * */

import React, { Component } from 'react'
import { Scrollbars } from 'react-custom-scrollbars'

import ThumbnailImage from '../ThumbnailImage'

import './styles.scss'

class ThumbnailStrip extends Component {
  render() {
    const { arcadeGalleryData, selectedIndex, onPress } = this.props
    return (
      <Scrollbars
        style={{
          overflow: 'initial'
        }}
        renderView={props => <div {...props} className="scrollBarView" />}
        renderThumbHorizontal={props => (
          <div {...props} className="scrollBarViewThumbHorizontal" />
        )}
      >
        {arcadeGalleryData.map((eachGalleryItem, index) => {
          const galleryID = eachGalleryItem.galleryImageAltText
            .split(' ')
            .join('')
          return (
            <ThumbnailImage
              onPress={onPress}
              currentGalleryItem={eachGalleryItem}
              selectedIndex={selectedIndex}
              currentIndex={index}
              arcadeGalleryData={arcadeGalleryData}
              id={`${galleryID}`}
            />
          )
        })}
      </Scrollbars>
    )
  }
}
export default ThumbnailStrip



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ArcadeGallery/ThumbnailStrip/index.js